import { getPropsFromNode, nodeListToArray } from '../utils'
import { ArticleCodeblock } from '../../components/molecule/ArticleContent/entry'
import { h } from '../parser/utils'

export const NAME = 'code'

export const COMPONENTS = {
  ArticleCodeblock,
}

export function matches(node) {
  return node.nodeName?.toLowerCase() === 'code'
}

export async function transform (node, next, ctx) {
  const nodes = nodeListToArray(node.childNodes)

  const children = await next(
    nodes.filter(node => node.nodeName.toLowerCase() !== 'br'),
    ctx,
  )

  const props = getPropsFromNode(node)

  return h(
    ArticleCodeblock,
    {
      ...props,
      offset: true,
    },
    ...children,
  )
}
